<script lang="ts" setup>
  import { useQuery } from '@pinia/colada';
  import { computed, ref } from 'vue';
  import { ApiError, reasonOf } from '../../../shared/api/client.ts';
  import {
    hostPlaylistsQuery,
    noHostSignIn,
    searchPlaylists,
    type SpotifyPlaylist,
  } from '../../../shared/api/playlists.ts';
  import { useFlag } from '../../../shared/config/flags.ts';
  import PlaylistsView from './PlaylistsView.vue';

  const playlistMode = useFlag('playlist-mode');
  const { data: mine, error } = useQuery(hostPlaylistsQuery);

  const found = ref<null | SpotifyPlaylist[]>(null);
  const searching = ref(false);

  const notSignedIn = computed(() => error.value instanceof ApiError && error.value.slug === noHostSignIn);

  const searchProblem = ref('');

  const search = async (words: string) => {
    searching.value = true;
    searchProblem.value = '';
    try {
      found.value = await searchPlaylists(words);
    } catch (problem) {
      searchProblem.value = reasonOf(problem);
    } finally {
      searching.value = false;
    }
  };
</script>

<template>
  <PlaylistsView
    v-if="playlistMode"
    :found="found"
    :mine="mine ?? []"
    :not-signed-in="notSignedIn"
    :search-problem="searchProblem"
    :searching="searching"
    @search="search"
  />
</template>
